
import createIconComponent from './utils/createIconComponent';
import { PICTOGRAM_LAPTOP_CHECK_STATIC } from '../../dist';

import React from 'react';
const LaptopCheckStatic = createIconComponent({ content: PICTOGRAM_LAPTOP_CHECK_STATIC, height: 48, width: 48 });
LaptopCheckStatic.displayName = 'LaptopCheckStatic';
export default LaptopCheckStatic;
